import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import store from './vuex';
import './assets/icon/iconfont.css'
import "./utils/permissions"
import * as echarts from 'echarts';


Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'small' });
Vue.prototype.$echarts = echarts;

import { timestampToTime } from '@/utils'
Vue.filter('timestampToTime', timestampToTime)



new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    data: {
        Bus: new Vue()
    }
})


// WEBPACK FOOTER //
// ./src/main.js